import React, { forwardRef } from 'react';
import styled from 'styled-components';
import {
    slate20,
    slate40,
    negativeLight,
    negativeMedium,
    negativeDark,
    white,
} from '@zocdoc-mezzanine/foundations-colors';
import BaseButton, { Size } from './private/BaseButton';

/**
 * DestructiveButton
 * @param {ButtonProps} props - Props for the button.
 * @returns {JSX.Element} DestructiveButton
 */

const DestructiveButton = forwardRef(({ className, ...props }, ref) => {
    const {
        fluid = true,
        size = Size.Default,
        disabled = false,
        onClick,
        href,
        children,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-describedby': ariaDescribedby,
        'data-test': dataTest,
        type,
        beforeClick,
        rel,
        target,
        title,
    } = props;
    return (
        <Button
            fluid={fluid}
            size={size}
            disabled={disabled}
            onClick={onClick}
            href={href}
            children={children}
            aria-describedby={ariaDescribedby}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledby}
            data-test={dataTest || 'destructive-btn'}
            ref={ref}
            type={type}
            beforeClick={beforeClick}
            rel={rel}
            target={target}
            title={title}
        />
    );
});

const Button = styled(BaseButton)`
    background-color: ${negativeMedium};
    color: ${white};

    &:hover {
        background-color: ${negativeLight};
    }

    &:active {
        background-color: ${negativeDark};
    }

    //use disabled as a prop since <a/> doesn't support disabled state
    ${({ disabled }) =>
        disabled &&
        `
            background-color: ${slate20};
            color: ${slate40};
            pointer-events: none;
        `}
`;

export default DestructiveButton;
